import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const withOnChangeAsNonEvent = (InputComponent) => {
   const WrappedComponent = (props) => {
      const onChangeNonEvent = useCallback((newInputValue) => {
         props.form.setFieldValue(props.field.name, newInputValue);
         if (props.onChange) {
            props.onChange(newInputValue);
         }

         // props.field.name is a dependent for input component that has dynamic name
      }, [props.field.name]);

      return (
         <InputComponent
            {...props}
            onChange={onChangeNonEvent}
         />
      );
   };

   WrappedComponent.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
      }).isRequired,
      form: PropTypes.shape({
         setFieldValue: PropTypes.func.isRequired,
      }).isRequired,
      onChange: PropTypes.func,
   };

   WrappedComponent.defaultProps = {
      onChange: undefined,
   };

   return WrappedComponent;
};

export default withOnChangeAsNonEvent;
